import React from "react";
import Slider from "react-slick";
import { Typography, Box, Button } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
const services = [
  {
    title: "Emergency Relief",
    image: "https://ik.imagekit.io/nfs93gxmp/Home%20Page%20Services/Emergency%20Relief.png",
     description: "Khadija Tul-Kubra Emergency Relief services is a trusted name in emergency needs...",
    link: "/releif-activity-pakistan",  
  },
  {
    title: "Self-Sufficiency Plans",
    image: "https://ik.imagekit.io/nfs93gxmp/Home%20Page%20Services/Self%20Sustainable.png",
    description:
      "Khadija Tul-Kubra Welfare Trust is working on self-sufficiency plans for the needy people in Pakistan...",
    link:"/self-sufficiency-plans"
  },
  {
    title: "Quranic Institutes Network",
    image: "https://ik.imagekit.io/nfs93gxmp/Home%20Page%20Services/Quranic%20Institutes.png",
    description:
      "Under the trust, about 30 Quranic schools have been established in the underprivileged areas of the country...",
    link:"/quranic-institutes-network"
  },
  {
    title: "Food Distribution",
    image: "https://ik.imagekit.io/nfs93gxmp/Home%20Page%20Services/Food%20Supply.png",
    description:
      "So far, food has been provided to more than 50,000 families under the Food Department. Details are as follows:...",
    link:"/food-supply"
  },
  {
    title: "Water Supply",
    image: "https://ik.imagekit.io/nfs93gxmp/Home%20Page%20Services/Water%20Supply.png",
    description:
      "Implemented 60+ water projects in different areas, including 28 solar water projects and 38 hand pumps.",
    link:"/water-supply"
  },
  {
    title: "Orphans Support",
    image: "https://ik.imagekit.io/nfs93gxmp/Home%20Page%20Services/Orphans%20Support.png",
    description:
      "Khadija Tul-Kubra aims to provide Orphans care center in Karachi, Pakistan...",
    link:"/orphans-support"
  },
];

const ServiceSlider = () => {
  const navigate = useNavigate();

const handleServiceClick = (link) => {
  window.scrollTo(0, 0);
  navigate(link);
};

const handleSeeAllClick = () => {
  window.scrollTo(0, 0);
  navigate("/services");
};


  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Adjust slides per view on mobile
    slidesToScroll: 1,
  };

  const navbarColor = "#0095b3"; // replace with your actual navbar hex color

return (
  <div
    style={{
      padding: "50px 20px",
      marginBottom: "20px",
      background: "linear-gradient(180deg, #e0f4f8 0%, #e8f7fa 40%, #f0fafc 100%)",
      marginTop: "24px",
      position: "relative",
    }}
  >
    {/* Decorative background elements */}
    <div style={{
      position: "absolute",
      top: 0,
      right: 0,
      width: "400px",
      height: "400px",
      background: `radial-gradient(circle, rgba(0,149,179,0.12) 0%, transparent 70%)`,
      borderRadius: "50%",
      transform: "translate(30%, -30%)",
    }} />
    <div style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "300px",
      height: "300px",
      background: `radial-gradient(circle, rgba(0,184,212,0.08) 0%, transparent 70%)`,
      borderRadius: "50%",
      transform: "translate(-30%, 30%)",
    }} />
    
    {/* Heading */}
    <div style={{ textAlign: "center", marginBottom: "60px", position: "relative", zIndex: 1 }}>
      <Typography
        variant="h3"
        sx={{
          color: navbarColor,
          fontWeight: "800",
          letterSpacing: "-1px",
          marginBottom: "16px",
          fontSize: { xs: "2rem", md: "3rem" },
          textTransform: "uppercase",
          letterSpacing: "2px",
        }}
      >
        Projects & Programs
      </Typography>
      <Typography
        variant="h6"
        sx={{
          color: "#555",
          fontWeight: "300",
          maxWidth: "700px",
          margin: "0 auto",
          lineHeight: "1.8",
          fontSize: "1.1rem",
        }}
      >
        Our welfare projects empower marginalized communities and aim to restore lives.
      </Typography>
    </div>

    {/* Mobile slider */}
    <Box sx={{ display: { xs: "block", md: "none" } }}>
      <Slider {...sliderSettings}>
        {services.map((service, index) => (
          <div key={index} style={{ padding: "8px" }}>
            <div
              style={{
                textAlign: "center",
                padding: "0",
                borderRadius: "20px",
                backgroundColor: "#ffffff",
                boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
                overflow: "hidden",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow = "0 12px 40px rgba(0,149,179,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.12)";
              }}
              onClick={() => handleServiceClick(service.link)}
            >
              <div style={{ position: "relative", overflow: "hidden" }}>
                <img
                  src={service.image}
                  alt={service.title}
                  style={{
                    width: "100%",
                    height: "220px",
                    objectFit: "cover",
                    transition: "transform 0.5s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `linear-gradient(to bottom, transparent 0%, rgba(0,149,179,0.3) 100%)`,
                  }}
                />
              </div>
              <div style={{ padding: "24px" }}>
                <Typography
                  variant="h5"
                  sx={{
                    marginTop: "8px",
                    color: navbarColor,
                    fontWeight: "700",
                    fontSize: "1.4rem",
                  }}
                >
                  {service.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    marginTop: "12px",
                    color: "#555",
                    fontSize: "0.95rem",
                    lineHeight: "1.6",
                  }}
                >
                  {service.description}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: "20px",
                    background: `linear-gradient(135deg, ${navbarColor} 0%, #00b8d4 100%)`,
                    "&:hover": { 
                      background: `linear-gradient(135deg, #007a8f 0%, ${navbarColor} 100%)`,
                      transform: "translateY(-2px)",
                      boxShadow: `0 6px 20px rgba(0,149,179,0.4)`,
                    },
                    padding: "12px 28px",
                    borderRadius: "25px",
                    textTransform: "none",
                    fontWeight: "600",
                    fontSize: "0.95rem",
                    transition: "all 0.3s ease",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleServiceClick(service.link);
                  }}
                >
                  Read More →
                </Button>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </Box>

    {/* Desktop grid - Image overlay style */}
    <Box
      sx={{
        display: { xs: "none", md: "grid" },
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "24px",
        maxWidth: "1400px",
        margin: "0 auto",
        position: "relative",
        zIndex: 1,
      }}
    >
      {services.slice(0, 6).map((service, index) => (
        <div
          key={index}
          style={{
            position: "relative",
            height: "400px",
            borderRadius: "16px",
            overflow: "hidden",
            cursor: "pointer",
            transition: "all 0.4s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.02)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
          onClick={() => handleServiceClick(service.link)}
        >
          <img
            src={service.image}
            alt={service.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.6s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              background: `linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.5) 50%, transparent 100%)`,
              padding: "32px 24px 24px",
              color: "#fff",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "#fff",
                fontWeight: "700",
                fontSize: "1.5rem",
                marginBottom: "12px",
                textShadow: "0 2px 10px rgba(0,0,0,0.5)",
              }}
            >
              {service.title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.9)",
                fontSize: "0.9rem",
                lineHeight: "1.6",
                marginBottom: "20px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {service.description}
            </Typography>
            <div
              style={{
                display: "inline-block",
                padding: "10px 24px",
                background: navbarColor,
                borderRadius: "25px",
                fontWeight: "600",
                fontSize: "0.9rem",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#00b8d4";
                e.currentTarget.style.transform = "translateX(5px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = navbarColor;
                e.currentTarget.style.transform = "translateX(0)";
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleServiceClick(service.link);
              }}
            >
              Learn More →
            </div>
          </div>
        </div>
      ))}

      {/* See All Services Button */}
      <div style={{ gridColumn: "span 3", textAlign: "center", marginTop: "40px" }}>
        <Button
          variant="contained"
          sx={{
            background: `linear-gradient(135deg, ${navbarColor} 0%, #00b8d4 100%)`,
            "&:hover": {
              background: `linear-gradient(135deg, #007a8f 0%, ${navbarColor} 100%)`,
              transform: "translateY(-3px)",
              boxShadow: `0 10px 30px rgba(0,149,179,0.4)`,
            },
            padding: "16px 48px",
            borderRadius: "30px",
            fontSize: "1.1rem",
            fontWeight: "700",
            textTransform: "none",
            transition: "all 0.3s ease",
          }}
          onClick={handleSeeAllClick}
        >
          See All Services →
        </Button>
      </div>
    </Box>
  </div>
);

};

export default ServiceSlider;
